import React, { Component } from 'react';

class ButtonDarkBlue extends Component {
    render() {
        let btnClassName = "bg-nexcaredefault border-darkblue"
        if (this.props.disabled) {
            btnClassName = "bg-gray-400 cursor-not-allowed"
        }

        return (
            <button
                type={this.props.type}
                id={this.props.id}
                onClick={this.props.onClick}
                className={this.props.className + " " + btnClassName + " bg-g rounded border text-white focus:outline-none px-10 py-2"}
                disabled={this.props.disabled}
            >
                {this.props.children}
            </button>
        );
    }
}

export default ButtonDarkBlue;